var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIconsDispatches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.75,
    height: 13.75,
    viewBox: "0 0 13.75 13.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875,0,0,1.719v8.594L6.875,13.75l6.875-3.437V1.719Zm0,.859,1.8.43L3.609,2.922,1.633,2.234Zm0,11.945L.859,9.8V2.836L3.438,3.7V6.617l.859.258V4.039L6.875,4.9Zm.43-8.68-2.32-.773,5.328-1.633,2.063.516L7.3,4.125Z",
    fill: "#888075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconsDispatches);
export default __webpack_public_path__ + "static/media/navIcons_Dispatches.d70e68af.svg";
export { ForwardRef as ReactComponent };